export default __webpack_public_path__ + "static/USA-046252c1726c9b460530f06c489b9828.svg";